import axios from "axios";
import { api } from "../config";
import decrypted from "../helper/decrpted";

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers.post["Accept"] = "application/json";
// content type
// const client_token = localStorage.getItem("client_token");
// const token = JSON.parse(sessionStorage.getItem("authUser"))
//   ? JSON.parse(sessionStorage.getItem("authUser")).token
//   : null;
// if (token) axios.defaults.headers.common["Authorization"] = "Bearer " + token;
// //(client_token);
// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response.data ? response.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    let message;
    switch (error.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        message = "Invalid credentials";
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      default:
        message = error.message || error;
    }
    return Promise.reject(message);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

// const userData = JSON.parse(sessionStorage.getItem("userData"));
// const decryptedResult = decrypted(userData);
// const userData = sessionStorage.getItem("userData");

// let decryptedResult = null;

// if (userData) {
//   try {
//     decryptedResult = decrypted(JSON.parse(userData));
//   } catch (e) {
//     console.error("Unable to decrypt userData", e);
//   }
// }
// console.log("chek the api helper ", decryptedResult.token)
class APIClient {
  /**
   * Fetches data from given url
   */

  //  get = (url, params) => {
  //   return axios.get(url, params);
  // };
  get = (url, params) => {
    let response;

    let paramKeys = [];

    if (params) {
      Object.keys(params).map((key) => {
        paramKeys.push(key + "=" + params[key]);
        return paramKeys;
      });
      const queryString =
        paramKeys && paramKeys.length ? paramKeys.join("&") : "";
      response = axios.get(`${url}?${queryString}`, params);
    } else {
      response = axios.get(`${url}`, params);
    }

    return response;
  };

  // get2 = (url, params) => {
  //   const i =
  //     "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjU1NjllNjVlOGU2N2VhYWIwZDVjMDlhNzA4ZjI0OTJjNzk5MGU3ZTIxNWE4ZTQxNGNjNTRlMGZjMjE4MDdiZjY3YjI2NGRiMTgzODdhODg4In0.eyJhdWQiOiI1IiwianRpIjoiNTU2OWU2NWU4ZTY3ZWFhYjBkNWMwOWE3MDhmMjQ5MmM3OTkwZTdlMjE1YThlNDE0Y2M1NGUwZmMyMTgwN2JmNjdiMjY0ZGIxODM4N2E4ODgiLCJpYXQiOjE2NzI4MjQyNjAsIm5iZiI6MTY3MjgyNDI2MCwiZXhwIjoxNzA0MzYwMjYwLCJzdWIiOiIxNSIsInNjb3BlcyI6W119.EEN7u0HuNEgYO8Aa4YIFPPVQV1-1SQ1-U6e5aO1KbzIwhhm4HF4FJHVxduTIJ0w5RswioCK7tn9ZaT1kcaYXuPV7Q_PTtNZB-hBpBdcXKfCaSx7i1lk665ht0GLnvDM7d5GV2xRWYNiPpNa_8Ek3tMHyVEKqd0vUT4_knxF25ii-NTrQgG0dgYRrUrN8-7SR2nNtzJ_JpRBm1GLDJ_GKl0_-PT2KqppvQk7rj_BDAQbM_5sy2Z8WcZlpA5JoMLXsFxTzVMNH63BcYtaFbIT-b9kZaHVOusY7JGaSQoDque5kDg_SD38OOyETS8EKvxs8sW0rfoDJWFVuvqeCMbI2YHaVo_AUdk06My4ftWu-dRGjGzzTcSmk_01R8lGXSq8C-6gnnGm8jEpUCLh_YTYJGMFc2RChQUo8mIMEgM_vfRUNjZD6zvE50LJWJwn9vXA7dccpe62Qys8lznIEGo4hk0zsvO0kPENH2cwrUvW5GO_ZqdJSZypvvrhxR1pEG064XJnqgPD8J5JJ81wDOS70XLtOTBevgwUWCJ_hbTU0KmaUUxvGz2tw8XR_CDQTSi97NIsR1rOboi4v96FuQFziOeYpabQtYljdI89PCRu5g0qt86xl3D1rBPhowHlDEyIpMYM2OyINHiG-PdF_RpXum7VaHz9Q2VfKjWMtveFV3XE";
  //   const headers = {
  //     "Content-Type": "application/json",
  //     Authorization: `Bearer ${i}`,
  //   };
  //   return axios.get(url, {
  //     headers: headers,
  //   });
  // };
  // /**
  //  * post given data to url
  //  */
  // create = (url, data) => {
  //   const i =
  //     "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjU1NjllNjVlOGU2N2VhYWIwZDVjMDlhNzA4ZjI0OTJjNzk5MGU3ZTIxNWE4ZTQxNGNjNTRlMGZjMjE4MDdiZjY3YjI2NGRiMTgzODdhODg4In0.eyJhdWQiOiI1IiwianRpIjoiNTU2OWU2NWU4ZTY3ZWFhYjBkNWMwOWE3MDhmMjQ5MmM3OTkwZTdlMjE1YThlNDE0Y2M1NGUwZmMyMTgwN2JmNjdiMjY0ZGIxODM4N2E4ODgiLCJpYXQiOjE2NzI4MjQyNjAsIm5iZiI6MTY3MjgyNDI2MCwiZXhwIjoxNzA0MzYwMjYwLCJzdWIiOiIxNSIsInNjb3BlcyI6W119.EEN7u0HuNEgYO8Aa4YIFPPVQV1-1SQ1-U6e5aO1KbzIwhhm4HF4FJHVxduTIJ0w5RswioCK7tn9ZaT1kcaYXuPV7Q_PTtNZB-hBpBdcXKfCaSx7i1lk665ht0GLnvDM7d5GV2xRWYNiPpNa_8Ek3tMHyVEKqd0vUT4_knxF25ii-NTrQgG0dgYRrUrN8-7SR2nNtzJ_JpRBm1GLDJ_GKl0_-PT2KqppvQk7rj_BDAQbM_5sy2Z8WcZlpA5JoMLXsFxTzVMNH63BcYtaFbIT-b9kZaHVOusY7JGaSQoDque5kDg_SD38OOyETS8EKvxs8sW0rfoDJWFVuvqeCMbI2YHaVo_AUdk06My4ftWu-dRGjGzzTcSmk_01R8lGXSq8C-6gnnGm8jEpUCLh_YTYJGMFc2RChQUo8mIMEgM_vfRUNjZD6zvE50LJWJwn9vXA7dccpe62Qys8lznIEGo4hk0zsvO0kPENH2cwrUvW5GO_ZqdJSZypvvrhxR1pEG064XJnqgPD8J5JJ81wDOS70XLtOTBevgwUWCJ_hbTU0KmaUUxvGz2tw8XR_CDQTSi97NIsR1rOboi4v96FuQFziOeYpabQtYljdI89PCRu5g0qt86xl3D1rBPhowHlDEyIpMYM2OyINHiG-PdF_RpXum7VaHz9Q2VfKjWMtveFV3XE";
  //   const headers = {
  //     headers: { "content-type": "application/x-www-form-urlencoded" },
  //     Authorization: `Bearer ${i}`,
  //   };
  //   return axios.post(url, data, {
  //     headers: headers,
  //   });
  // };

  postMethodWithTokenType = (url, data) => {
    const userData = sessionStorage.getItem("userData");
    var decryptedResult = decrypted(JSON.parse(userData));
    const i = decryptedResult.token;

    const headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      Authorization: `Bearer ${i}`,
    };
    return axios.post(url, data, {
      headers: headers,
    });
  };

  postLoginOneTokken = (url, data) => {
    console.log("chekc the api helper ")
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.post(url, data, {
      headers: headers,
    });
  };

  postLoginTokken = (url, data) => {
    const userData = sessionStorage.getItem("userData");
    var decryptedResult = decrypted(JSON.parse(userData));
    const i = decryptedResult.token;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${i}`,
    };
    return axios.post(url, data, {
      headers: headers,
    });
  };

  postRawApi = (url, data) => {
    const userData = sessionStorage.getItem("userData");
    var decryptedResult = decrypted(JSON.parse(userData));
    const i = decryptedResult.token;
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${i}`,
    };
    return axios.post(url, data, {
      headers: headers,
    });
  };



  update = (url, data) => {
    return axios.patch(url, data);
  };

  put = (url, data) => {
    return axios.put(url, data);
  };
  /**
   * Delete
   */
  delete = (url, config) => {
    return axios.delete(url, { ...config });
  };
}
const getLoggedinUser = () => {
  const user = sessionStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
